export const W_LOWERCASE = 87

export const keyCodes = {
  w: W_LOWERCASE,
}
